/**
 * @fileoverview CSS module for the Dropdown component.
 * Contains styles for the dropdown menu, trigger button, label and container.
 *
 * @example
 * // Import and use in component
 * import css from './Dropdown.module.css'
 *
 * <div className={css.container}>
 *   <label className={css.label}>Select option</label>
 *   <div className={css.listbox}>
 *     <button className={css.trigger}>Click me</button>
 *   </div>
 * </div>
 */


.label {
    display: block;
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.017em;
    text-align: left;
    margin-bottom: 8px;
}

.listbox {
    width: 100%;
    display: flex;
}

.container {
    position: relative;
    flex-direction: column;
    display: flex;
    width: auto;
}

.trigger {
    display: flex;
    gap: 0.5rem;
    font-family: Inter;
    width: 100%;
    height: 3.5rem;
    padding: 0.5rem 0.8rem;
    align-items: center;
    flex-shrink: 0;
    border-radius: 0.75rem;
    border: 1px solid var(--neutural400);
    background-color: #fff;
    font-size: 1.125rem;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    transition: all 0.2s ease-in-out;
    font-weight: 400;
    color: var(--neutural900);
    appearance: none;
}

.trigger:disabled {
    background-color: var(--neutural100);
    color: var(--neutural900);
    border-color: var(--neutural400);
}

.placeholder {
    color: var(--neutural500);
}

.trigger:not([disabled]):hover,
.trigger:not([disabled]):focus,
.trigger:not([disabled]):active {
    border-color: var(--neutural900);
}

.options {
    position: absolute;
    max-height: 250px;
    width: 100%;
    margin: 3.5rem 0 0;
    padding: 0.5rem 0;
    border-radius: 0.75rem;
    list-style: none;
    z-index: 10;
    background: var(--neutural000);
    border: 1px solid var(--neutural400);
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.option {
    height: 1.5rem;
    padding: 1rem 0.8rem;
    cursor: pointer;
    gap: 0.5rem;
    display: flex;
    user-select: none;
}

.option .disabled {
    color: var(--neutural500);
}

.option:not(.selected).active,
.option:not(.selected):hover,
.option:not(.selected):focus,
.option:not(.selected):active {
    background-color: var(--indigo50);
    text-decoration: underline;
    text-underline-offset: 2px;
}

.placeholder {
    color: var(--neutural500);
}

.error {
    outline: 6px solid var(--red300);
    border-color: var(--neutural900);
}

.errorMessage {
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: var(--red700);
}

.chevron {
    position: absolute;
    top: 1rem;
    pointer-events: none;
    right: 1rem;
    height: 24px;
    width: 24px;
}
